import {
  ActivityDrawer,
  DrawerMessenger,
  ExploreMain,
  InviteUsers,
  Main,
  UpgradePlan,
} from '../partials'

import {Content} from './components/Content'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {MasterInit} from './MasterInit'
import {PageDataProvider} from './core'
import React from 'react'
import {ScrollTop} from './components/ScrollTop'

const MasterLayout: React.FC = ({children}) => {
  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root'>
        <div className='page d-flex flex-row flex-column-fluid'>
          {/* <AsideDefault /> */}
          <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
            <HeaderWrapper />

            <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
              {/* <Toolbar /> */}
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>{children}</Content>
              </div>
            </div>
            {/* <Footer /> */}
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      {/* <ExploreMain /> */}
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}

      <MasterInit />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
